import type { Element } from './elements.js';

export type MonsterModel = 'wolf' | 'bandit';

export interface MonsterDef {
  id: string;
  name: string;
  level: number;
  model: MonsterModel;
  element: Element;
  maxHp: number;
  atk: number;
  def: number;
  evasion: number;
  crit: number;
  radius: number;
  walkSpeed: number;
  chaseSpeed: number;
  aggroRadius: number;
  /** Distance from the spawn point beyond which the monster gives up and returns. */
  leashRadius: number;
  /** Nearby monsters of the same id within this radius join the fight. 0 disables. */
  assistRadius: number;
  attacks: string[];
  xp: number;
  lootTable: string;
  respawnMs: number;
  colors: { body: string; accent: string };
  scale: number;
}

export const MONSTERS: Readonly<Record<string, MonsterDef>> = {
  grey_wolf: {
    id: 'grey_wolf',
    name: 'Grey Meadow Wolf',
    level: 1,
    model: 'wolf',
    element: 'wood',
    maxHp: 70,
    atk: 8,
    def: 3,
    evasion: 0.03,
    crit: 0.05,
    radius: 0.6,
    walkSpeed: 2.0,
    chaseSpeed: 4.9,
    aggroRadius: 8,
    leashRadius: 24,
    assistRadius: 5,
    attacks: ['wolf_bite'],
    xp: 40,
    lootTable: 'grey_wolf',
    respawnMs: 15000,
    colors: { body: '#8a8986', accent: '#5b5753' },
    scale: 1,
  },
  mountain_bandit: {
    id: 'mountain_bandit',
    name: 'Mountain Bandit',
    level: 3,
    model: 'bandit',
    element: 'metal',
    maxHp: 165,
    atk: 15,
    def: 8,
    evasion: 0.04,
    crit: 0.06,
    radius: 0.45,
    walkSpeed: 1.8,
    chaseSpeed: 4.6,
    aggroRadius: 10,
    leashRadius: 26,
    assistRadius: 9,
    attacks: ['bandit_heavy_chop', 'bandit_slash'],
    xp: 85,
    lootTable: 'mountain_bandit',
    respawnMs: 22000,
    colors: { body: '#6b4f3a', accent: '#8e2f2a' },
    scale: 1.05,
  },
};

export function getMonster(id: string): MonsterDef | undefined {
  return MONSTERS[id];
}
